import React from 'react'
import { useLocalDataCache } from 'hooks'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'

export default function RecordsBreadcrumbs() {
  const { breadcrumbs, setBreadcrumbs } = useLocalDataCache()
  const actionBreadcrumbs = breadcrumbs.map((breadcrumb, i) => ({
    ...breadcrumb,
    onClick: () => setBreadcrumbs((current) => current.slice(0, i)),
  }))
  return breadcrumbs ? <Breadcrumbs breadcrumbs={actionBreadcrumbs} /> : null
}
